import { Body2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { type FC } from 'react';

import styles from './MedalsCard.css';

type TMedalsCardProps = {
  gold: number;
  silver: number;
  bronze: number;
};

export const MedalsCard: FC<TMedalsCardProps> = ({ gold, silver, bronze }) => {
  return (
    <div className={styles['card']} data-testid="MedalsCard">
      <div className={styles['medals']}>
        <div className={clsx(styles['medal'], styles['gold'])}>
          <div className={styles['medal-label']}>{gold}</div>
        </div>
        <div className={clsx(styles['medal'], styles['silver'])}>
          <div className={styles['medal-label']}>{silver}</div>
        </div>
        <div className={clsx(styles['medal'], styles['bronze'])}>
          <div className={styles['medal-label']}>{bronze}</div>
        </div>
      </div>
      <Body2>
        Побед в конкурсе <br />
        топ ЖК
      </Body2>
    </div>
  );
};
